/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartChordDiagram = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zM7.879 18.804l-.038.031a8.002 8.002 0 0 0 12.097-5.834h-8.993a8.971 8.971 0 0 1-3.066 5.803zm1.05-5.803h-1.93c-1.031 0-1.996.39-2.727 1.072a7.978 7.978 0 0 0 1.972 3.483A6.978 6.978 0 0 0 8.929 13zM6.244 6.444l-.141.15A7.971 7.971 0 0 0 4 12l.002-.2a5.982 5.982 0 0 1 2.716-.793L6.999 11h1.93a6.98 6.98 0 0 0-2.685-4.556zm6.671-2.392-.01.068a8.01 8.01 0 0 1-.555 1.89c-.458 1.055-1.138 1.91-2.066 2.475.338.792.563 1.638.66 2.515h.641l5.32-5.32a7.96 7.96 0 0 0-3.99-1.628zm5.405 3.042L14.413 11h5.525a7.96 7.96 0 0 0-1.618-3.906zm-7.452-3.013-.094.012a7.949 7.949 0 0 0-2.933 1.072c.55.468 1.038.997 1.456 1.574.53-.34.928-.856 1.218-1.525a5.78 5.78 0 0 0 .353-1.133z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartChordDiagram as ChartChordDiagram };
